module.exports = __webpack_public_path__ + "static/media/dash.7c5f0d28.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/dash.svg
// module id = 591
// module chunks = 0